export class SnapshotHistogramBucket {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketStart",
            "baseName": "bucketStart",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "snapshotCount",
            "baseName": "snapshotCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "resourcesWithSnapshotCount",
            "baseName": "resourcesWithSnapshotCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "threatSnapshotCount",
            "baseName": "threatSnapshotCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotHistogramBucket.attributeTypeMap;
    }
    constructor() {
    }
}
